import React, { useEffect, useState } from "react";
import ReactDOM from "react-dom";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import qs from "qs";
import { ApolloProvider } from "@apollo/client";

import AboutUs from "./AboutUs";
import Categories from "./common-components/Categories";
import Contacts from "./Contacts";
import Footer from "./footer/Footer";
import Products from "./Products";
import Header from "./header/Header";
import Home from "./home/index";
import MainContext from "../../context/Main";
import NotFound from "./NotFound";
import OurReps from "./OurReps";
import ProductsPage from "./ProductsPage";
import Resources from "./Resources";
import Warrant from "./Warrant";
import SearchResult from "./WebsiteSearch/SearchResult";
import { client } from "../../services/constants";
import CollectionPage from "./common-components/Collection/CollectionPage";
import LearnMore from "./LearnMore";
import ProductDetail from "./ProductDetail";
import CaseStudies from "./CaseStudies";
import CustomWork from "./CustomWork";
import CustomFabrication from "./CustomFabrication";

export default function Main() {
    /*
    ----------states for context---------------------------------*/

    //for email specification
    const [selectProductName, setSelectProductName] = useState("");
    const [selectPdfUrl, setSelectPdfUrl] = useState("");

    //for search
    const [totalProducts, setTotalProducts] = useState(null);
    const [totalCollections, setTotalCollections] = useState(null);
    const [totalCategories, setTotalCategories] = useState(null);
    const [keywords, setKeywords] = useState(null);

    /*--------------------------------------------------------------
       START OF COMMENT---------------------------------------------
       The code in the comment is intended to work with products.
       It pulls in all the products from the strap and displays them
       on the page under the /products path.*/
    /*
    ----------local states------------------------------------------*/
    // const [selectProducts, setSelectProducts] = useState([]);
    // const [productsIsLoaded, setProductsIsLoaded] = useState(false);
    // const [qtyAllStrapiProds, setQtyAllStrapiProds] = useState(null);

    // useEffect(() => {
    //     fetch(`/api/products`)
    //         .then((response) => {
    //             return response.json();
    //         })
    //         .then((products) => {
    //             setQtyAllStrapiProds(products.meta.pagination.total);
    //         });
    // }, []);

    // useEffect(() => {
    //     if (qtyAllStrapiProds) handleSetCollection();
    // }, [qtyAllStrapiProds]);

    // const handleSetCollection = (collectionName = null) => {
    //     setProductsIsLoaded(false);

    //     const query = qs.stringify(
    //         {
    //             populate: "*",
    //             pageSize: qtyAllStrapiProds,
    //             filterNameCollection: collectionName,
    //         },
    //         {
    //             encodeValuesOnly: true,
    //         }
    //     );

    //     fetch(`/api/products?${query}`)
    //         .then((response) => {
    //             return response.json();
    //         })
    //         .then((products) => {
    //             setSelectProducts(products.data);
    //         })
    //         .then(() => {
    //             setProductsIsLoaded(true);
    //         });
    // };
    /*-------------------------------------------------------
      END OF COMMENT*/

    return (
        <div className="d-flex flex-column min-vh-100 main-container">
            <ApolloProvider client={client}>
                <BrowserRouter>
                    <MainContext.Provider
                        value={{
                            selectProductName,
                            setSelectProductName,
                            selectPdfUrl,
                            setSelectPdfUrl,
                            totalProducts,
                            setTotalProducts,
                            totalCollections,
                            setTotalCollections,
                            totalCategories,
                            setTotalCategories,
                            keywords,
                            setKeywords
                        }}
                    >
                        <Header
                            onSelectCollection={name => {
                                // handleSetCollection(name)
                            }}
                        />
                        <div className="flex-fill mt-5">
                            <Routes>
                                <Route path="/" element={<Home />} />
                                <Route
                                    path="/products"
                                    element={<Products />}
                                />
                                <Route
                                    path="/products/category/:productName"
                                    element={<Products />}
                                />
                                {/* ------------------------------------------------------
                                The code in the comment is intended to work with products.
                                Uses commented out variables above.

                                 <Route path="products">
                                    <Route
                                        index
                                        element={
                                            <ProductsPage
                                                selectProducts={selectProducts}
                                                productsIsLoaded={
                                                    productsIsLoaded
                                                }
                                            />
                                        }
                                    />
                                    <Route
                                        path=":productName"
                                        element={<Product />}
                                    />
                                </Route> */}
                                <Route path="/collection">
                                    <Route
                                        index
                                        element={<h1>Select a collection</h1>}
                                    />
                                    <Route
                                        path=":collectionName"
                                        element={<CollectionPage />}
                                    />
                                </Route>
                                <Route path="category">
                                    <Route
                                        index
                                        element={<h1>Select a category</h1>}
                                    />
                                    <Route
                                        path=":categoryName"
                                        element={<Categories />}
                                    />
                                </Route>

                                <Route
                                    path="/resources"
                                    element={<Resources />}
                                />
                                <Route
                                    path="/warranty-docs"
                                    element={<Warrant />}
                                />


                                <Route path="/custom-fabrication" element={<CustomFabrication />} />
                                <Route path="/custom-work" element={<CustomWork />} />
                                <Route path="/case-study" element={<CaseStudies />} />
                                <Route path="/our-reps" element={<OurReps />} />
                                <Route path="/about-us" element={<AboutUs />} />
                                <Route path="/contacts" element={<Contacts />} />
                                <Route path="/learn" element={<LearnMore />} />
                                <Route
                                    path="/product-detail"
                                    element={<ProductDetail />}
                                />
                                <Route
                                    path="/search"
                                    element={<SearchResult key="reload" />}
                                />
                                <Route path="*" element={<NotFound />} />
                            </Routes>
                        </div>
                        <Footer />
                    </MainContext.Provider>
                </BrowserRouter>
            </ApolloProvider>
        </div>
    );
}
// DOM element
if (document.getElementById("main")) {
    ReactDOM.render(<Main />, document.getElementById("main"));
}
